import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office sees the "Select a Professional Type" popup
 * Event: dental_portal:shift_request:professional_type_popup_viewed
 */
export function fireProfessionalTypePopupViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:professional_type_popup_viewed', {
    'Design Date': 202603,
  });
}
